import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import Switch from '@mui/material/Switch';

import api from '../../API/api';

import GeneralAction from '../panel/generalAction';



export default function ViewNotice(props) {

    const navigation = useNavigate()



    const [notice, setNotice] = useState();

    useEffect(() => {
        getEvents()
        
    }, [])


    const getEvents = () => {
        api.getEvents().then((res) => {
            // console.log(res);
            setNotice(res.data.notice);
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    // const [status, setStatus] = useState(true);
    const changeNoticeStatus = (id, status) => {
        // console.log(id, status);
        api.changeNoticeStatus(id, status).then((res) => {
            console.log(res);
            getEvents();
        })
            .catch((err) => {
                // console.log(err.response);
            })

    }




    return (
        <div className='py-3'>
            {/* <div className="row">
                <div className='py-3'>
                    <Button variant='contained' color='error' fullWidth>{props.school && props.school.schoolName}</Button>
                </div>
            </div> */}

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead sx={{ backgroundColor: 'black' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Notice</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} > Date</TableCell>

                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Status</TableCell>

                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {notice && notice.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell > {row.notice} </TableCell>
                                <TableCell > {row.created_at} </TableCell>
                                <TableCell > {row.isActive === 1 ? 
                                <span className='text-success'>
                                Active
                                </span>
                                 : 
                                 <span className='text-danger'>
                                     Inactive
                                 </span>
                                
                                }
                                    <Switch
                                        checked={row.isActive}
                                        onChange={() => changeNoticeStatus(row.id, row.isActive)}
                                        name="loading"
                                        color="primary"
                                    />
                                </TableCell>
                                <TableCell align="right"> <Button size='small'> <GeneralAction data={row} handleClickOpen={props.handleClickOpen} /> </Button> </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}